import React from "react"
import {Link} from "gatsby"


export default function Header(props) {

  return (
    <div className = "fullHeader">

      <div className = "headerLinks"><Link to="/" className='link' id ='homeButton'>Mold Fashioned</Link></div>
      <div className = "headerLinks">
      <Link to="/blog/" className='link'>Blog</Link>
      <Link to="/about/" className='link'>About</Link>
      <Link to="/contact/" className='link'>Contact</Link>
      </div>

    </div>
  )
}
